import { useCallback, useState } from "react";
import { pages } from "../../data/local";
import { PageType, SingularPage } from "../../types";

export function useCatalog() {
  const [currentPage, setCurrentPage] = useState(pages[0]);

  const setPageOnType = useCallback((type: PageType) => {
    const page = pages.find((p) => p.type === type);
    setCurrentPage(page ?? pages[0]);
  }, []);

  const scrollPage = useCallback((val: number) => {
    setCurrentPage((cp: SingularPage) => {
      const currentIndex = pages.findIndex((p) => p.type === cp.type);
      // scroll to end, if going further back than 0
      if (currentIndex + val < 0) {
        return pages[pages.length - 1];
        // scroll to start, if going further than end
      } else if (currentIndex + val > pages.length - 1) {
        return pages[0];
      }
      // just add scroll
      return pages[currentIndex + val];
    });
  }, []);

  return { currentPage, setPageOnType, scrollPage };
}
